// extracted by mini-css-extract-plugin
export var addToCartButton = "_sl-b";
export var arrowButtonContainer = "_sl-9";
export var arrowButtonIcon = "_sl-a";
export var carouselArrowButton = "_sl-6";
export var carouselElementContainer = "_sl-1";
export var galleryThumbnail = "_sl-d";
export var galleryThumbnailImage = "_sl-e";
export var left = "_sl-7";
export var productDisplayCarouselContainer = "_sl-0";
export var productTileContainer = "_sl-2";
export var productTileImage = "_sl-4";
export var productTileImageContainer = "_sl-3";
export var productTileTitle = "_sl-5";
export var right = "_sl-8";
export var sliderOverflow = "_sl-c";